import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import projects from '../data/projects';

const ProjectCard = ({ className, limit }) => {
  const { t } = useTranslation();
  const displayedProjects = limit ? projects.slice(0, limit) : projects;

  return (
    <>
      {displayedProjects.map((project) => (
        <div className={className} key={project.id}>
          <div className="project-card">
            <div className="project-img">
              <img src={project.img} alt={t(project.subtitleKey)} />
            </div>
            <div className="project-content">
              <p className="project-subtitle">{t(project.subtitleKey)}</p>
              <h3 className="box-title">
                <Link to={project.detailsLink}>{t(project.titleKey)}</Link>
              </h3>
              <Link to={project.detailsLink} className="link-btn">
                {t('sections.projectCard.read_more', 'Read More')}<i className="far fa-long-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ProjectCard;